import { FC, useContext, useEffect } from 'react';

import { StepTwoFormContext } from '../../../StepTwo/contexts';
import { StepThreeFormContext } from '../../contexts';

import { CoveragesPersonalEffects } from '../CoveragesPersonalEffects';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';

interface PersonalEffectsQuotationFormByTabProps {
  tabKey: number;
}

export const PersonalEffectsQuotationFormByTab: FC<
  PersonalEffectsQuotationFormByTabProps
> = ({ tabKey }) => {
  const { stepThreePersonalEffectsQuotationForm } =
    useContext(StepThreeFormContext);

  const { planOptionsBySelectedPlan, stepTwoForm } =
    useContext(StepTwoFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  useEffect(() => {
    if (planSelected) {
      stepThreePersonalEffectsQuotationForm.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  }, [planSelected, stepThreePersonalEffectsQuotationForm, tabKey]);

  return (
    <>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${tabKey}`,
              }}
              selectProps={{
                placeholder: 'Seleccionar',
                options: planOptionsBySelectedPlan,
                disabled: true,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <CoveragesPersonalEffects tabKey={tabKey} />
    </>
  );
};
